export default __webpack_public_path__ + "static/media/cloth_04.4d698ddf.jpg";